(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-eo-home-interest]';
  var DEFAULT_ENDPOINT = '/a/r/_interest';
  var DEFAULT_ERROR = 'Something went wrong. Please try again.';

  function safeErrorMessage(value) {
    if (typeof value !== 'string') return DEFAULT_ERROR;
    var message = value.trim();
    return message && message.length <= 180 ? message : DEFAULT_ERROR;
  }

  function showError(error, message) {
    error.textContent = safeErrorMessage(message);
    error.hidden = false;
    error.focus();
  }

  function validateContactFields(form, payload, error) {
    var phone = form.elements.namedItem('phone');
    var email = form.elements.namedItem('email');
    if (phone && typeof phone.setCustomValidity === 'function') phone.setCustomValidity('');
    if (email && typeof email.setCustomValidity === 'function') email.setCustomValidity('');

    var phoneDigits = payload.phone.replace(/\D/g, '');
    if (phoneDigits.length < 7 || phoneDigits.length > 15) {
      var phoneMessage = 'Enter a valid phone number with 7 to 15 digits.';
      if (phone && typeof phone.setCustomValidity === 'function') {
        phone.setCustomValidity(phoneMessage);
        phone.reportValidity();
      }
      showError(error, phoneMessage);
      return false;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(payload.email)) {
      var emailMessage = 'Enter a valid email address.';
      if (email && typeof email.setCustomValidity === 'function') {
        email.setCustomValidity(emailMessage);
        email.reportValidity();
      }
      showError(error, emailMessage);
      return false;
    }

    return true;
  }

  function endpointFor(root) {
    var configured = root.getAttribute('data-endpoint') || DEFAULT_ENDPOINT;
    try {
      var url = new URL(configured, window.location.origin);
      if (url.origin !== window.location.origin) return DEFAULT_ENDPOINT;
      return url.pathname + url.search;
    } catch {
      return DEFAULT_ENDPOINT;
    }
  }

  function newSubmissionId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (character) {
      var random = Math.floor(Math.random() * 16);
      var value = character === 'x' ? random : (random & 3) | 8;
      return value.toString(16);
    });
  }

  function initialize(root) {
    if (!root || root.dataset.eoInterestBound === 'true') return;

    var formPanel = root.querySelector('[data-eo-form-panel]');
    var form = root.querySelector('[data-eo-interest-form]');
    var success = root.querySelector('[data-eo-interest-success]');
    var error = root.querySelector('[data-eo-interest-error]');
    var submitButton = root.querySelector('[data-eo-interest-submit]');
    var submitLabel = root.querySelector('[data-eo-interest-submit-label]');
    if (!form || !formPanel || !success || !error || !submitButton || !submitLabel) return;

    root.dataset.eoInterestBound = 'true';
    var pendingSubmissionId = '';

    ['phone', 'email'].forEach(function (name) {
      var field = form.elements.namedItem(name);
      if (!field || typeof field.addEventListener !== 'function') return;
      field.addEventListener('input', function () {
        field.setCustomValidity('');
        error.hidden = true;
      });
    });

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (!form.reportValidity()) return;

      var values = new FormData(form);
      if (!pendingSubmissionId) pendingSubmissionId = newSubmissionId();
      var payload = {
        submission_id: pendingSubmissionId,
        restaurant_name: String(values.get('restaurant_name') || '').trim(),
        contact_name: String(values.get('contact_name') || '').trim(),
        phone: String(values.get('phone') || '').trim(),
        email: String(values.get('email') || '').trim(),
        consent: values.get('consent') === 'yes' ? 'yes' : '',
        website: String(values.get('website') || '').trim()
      };

      error.hidden = true;
      error.textContent = DEFAULT_ERROR;
      if (!validateContactFields(form, payload, error)) return;
      form.setAttribute('aria-busy', 'true');
      submitButton.disabled = true;
      submitLabel.textContent = 'SENDING…';

      try {
        var response = await fetch(endpointFor(root), {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });
        var contentType = response.headers.get('content-type') || '';
        var result = contentType.indexOf('application/json') === -1
          ? null
          : await response.json().catch(function () { return null; });
        if (!response.ok || !result || result.ok !== true) {
          throw new Error(safeErrorMessage(result && result.error));
        }

        form.reset();
        pendingSubmissionId = '';
        formPanel.hidden = true;
        success.hidden = false;
        success.focus();
      } catch (requestError) {
        showError(error, requestError && requestError.message);
      } finally {
        form.removeAttribute('aria-busy');
        submitButton.disabled = false;
        submitLabel.textContent = 'HAVE US REACH OUT';
      }
    });
  }

  function initializeWithin(scope) {
    if (scope.matches && scope.matches(ROOT_SELECTOR)) initialize(scope);
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initialize);
  }

  function boot() {
    initializeWithin(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });
})();
